define('../app/fukit/service/notification.service',['require','exports','module','underscore','backbone','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Backbone = require('backbone'),
      UIKit    = require('uikit/uikit');

  var NotificationService = _.extend({}, Backbone.Events, {
    channelName: 'notificationService',

    radioRequests: {
      showNotification: 'showNotification',
    },

    showNotification: function(message) {
      if (!this.notifications) {
        this.notifications = new UIKit.InstantNotifications();
        document.querySelector('body').appendChild(this.notifications.el);
        this.notifications.render();
        this.notifications.triggerMethod('show', this.notifications);
      }
      this.notifications.add({ details: message });
    },
  });

  module.exports = NotificationService;
});

